import { Viewer } from "../auth/types";

type ViewerList = NonNullable<Viewer["lists"]>[number];

// Gates the header app-list nav on the server-authoritative showsInAppList flag
// (established/non-draft properties are always visible; draft/onboarding ones are
// gated until the Formstack form completes — see Property.shows_in_app_list?/1).
export const visibleNavLists = (
  lists: Viewer["lists"] | null | undefined,
  waitlist: boolean,
): ViewerList[] =>
  (lists ?? []).filter(
    (list) =>
      list.showsInAppList !== false &&
      (!waitlist || list.scheduledUpdate?.enabled),
  );
